import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { GetProductCategoriesBySearchDocument, GetProductCategoriesBySearchQuery } from "__generated__/view/productcategories/graphql/queries.generated";
import { ChildPropsFromPagination } from "types/commons";

export type ProductCategoryOption = Pick<ChildPropsFromPagination<GetProductCategoriesBySearchQuery, "productCategoriesBySearch">, "id" | "name">

const ProductCategorySelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<ProductCategoryOption, Multiple>, "fetchOptions">) => {

	const client = useApolloClient();

	const onFetchOptions = async(params: string, page: number) => {
		try  {
			const result = await client.query({
				query: GetProductCategoriesBySearchDocument,
				variables: {
					name: params,
					pagination: {
						page: page - 1,
						size: 5,
					},
				},
			});

			return {
				options: result.data.productCategoriesBySearch.content as ProductCategoryOption[],
				totalResults: result.data.productCategoriesBySearch.totalElements,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			paginated />
	);
};

export default ProductCategorySelect;
